<template>
    <div class="scenery">
      <router-link :to="{ name: 'home'}">
        <img src="/img/Logo.png" alt="Logo">
      </router-link>
      <div class="stars">
        <div v-for="i in count" :key="i" class="star"></div>
      </div>
      <div class="title">
        <h1>
          <span>4</span>
          <span class="zero">0</span>
          <span>3</span>
        </h1>
      </div>
      <div class="message">
        <h2>Oops! You are not authorized to access this page.</h2>
      </div>
      <div class="action">
        <Button @click="goBack" label="Go back" />
      </div>
    </div>
  </template>

  <script>
  export default {
    name: 'unauthorized',
    data() {
    return {
      count: 60 // Total number of stars
    };
  },
  methods:{
    goBack() {
      const referrer = document.referrer;
      const currentHost = window.location.host;
      if (!referrer || referrer === '' || !referrer.includes(currentHost)) {
        this.$router.push({ name: 'home' });
      } else {
        this.$router.go(-1);
      }
    }
  }
  }
  </script>

  <style lang="scss" scoped>

$count: 100;
$shadow: #FC6C2A;
$light: #fedbae;
$gradient1: #003E75;
$gradient2: #4D94D2;
$squareSize: 150px;

// mixins.scss

// Gradient Background Mixin
@mixin background-image($gradient) {
  background: $gradient;
  background: -webkit-linear-gradient($gradient);
  background: -moz-linear-gradient($gradient);
  background: -o-linear-gradient($gradient);
  background: -ms-linear-gradient($gradient);
}

// Box Shadow Mixin
@mixin box-shadow($shadow) {
  -webkit-box-shadow: $shadow;
  -moz-box-shadow: $shadow;
  -ms-box-shadow: $shadow;
  box-shadow: $shadow;
}

// Border Radius Mixin
@mixin border-radius($radius) {
  -webkit-border-radius: $radius;
  -moz-border-radius: $radius;
  -ms-border-radius: $radius;
  border-radius: $radius;
}

// Transition Mixin
@mixin transition($properties) {
  -webkit-transition: $properties;
  -moz-transition: $properties;
  -o-transition: $properties;
  transition: $properties;
}

// Transform Mixin
@mixin transform($transforms) {
  -webkit-transform: $transforms;
  -moz-transform: $transforms;
  -ms-transform: $transforms;
  transform: $transforms;
}


@keyframes shining {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}

body {
  background-color: #482472;
}
//---------------------------
// GENERAL SCENERY
//---------------------------
.zero {
    @include background-image(linear-gradient($gradient2, #FC6C2A));
    -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.scenery {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
  overflow: hidden;
  border-radius: 5px;
  color: #fff;
  @include background-image(linear-gradient($gradient1, $gradient2));
  @include box-shadow(rgba(0,0,0,0.8) 0px 0px 100px);
}
//---------------------------
// STARS
//---------------------------
.star {
  position: absolute;
  z-index: 1;
  background-color: #fff;
  animation-name: shining;
  animation-timing-function: ease;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  @include box-shadow(#fff 0px 0px 5px);
  @include border-radius(200px);
}
@for $i from 1 to $count {
  $size: random(3)+0px;
  .star:nth-child(#{$i}) {
    width: $size;
    height: $size;
    bottom: random(618)+0px;
    left: random(1000)+0px;
    animation-duration: random(4) / random(3) + 0s;
  }
//---------------------------
// TEXT
//---------------------------
}
.title {
  position: relative;
  z-index: 50;
  h1 {
    font-size: 15rem;
    font-weight: bold;
    span {
      vertical-align: middle;
      margin: 0 4px;
    }
  }
}
.message {
  //margin-top: 50px;
  h2 {
    font-size: 1.8rem;
  }
}
.action {
  margin-top: 10px;
  button {
    padding: 8px 16px;
    font-size: 1.2rem;
    color: #fff;
    border: 2px solid $shadow;
    background-color: $shadow;
    border-radius: 50px;
    @include transition(all .2s ease);
    box-shadow: 0px 0px 15px $shadow;
    &:hover {
      cursor: pointer;
      background-color: transparent;
    }
//---------------------------
// FIGURE
//---------------------------
  }
}
.square {
  width: $squareSize;
  height: $squareSize;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  left: -30px;
  @include transform(scale(1.1) rotate(45deg));
  > * {
    position: absolute;
  }
  .light {
    box-shadow: 0px 0px 10px $light;
    background-color: $light;
  }
  .light1,
  .light3 {
    width: $squareSize / 10;
    height: $squareSize - $squareSize / 10;
    @include transform(skew(0deg, 45deg));
  }
  .light2,
  .light4 {
    width: $squareSize - $squareSize / 5;
    height: $squareSize / 10;
    @include transform(skew(45deg));
  }
  .light1 {
    z-index: 10;
    top: $squareSize / 20 - 2px;
    left: $squareSize / 10;
  }
  .light3 {
    z-index: 2;
    top: $squareSize / 20;
    right: $squareSize / 10;
  }
  .light2 {
    top: 0;
    left: $squareSize / 10 + ($squareSize / 10)/2;
  }
  .light4 {
    bottom: 0;
    right: $squareSize / 10 + ($squareSize / 10)/2;
  }
  .shadow {
    background-color: $shadow;
    box-shadow: 0px 0px 10px $shadow;
  }
  .shadow1 {
    bottom: $squareSize / 20;
    right: 0;
    width: $squareSize / 10;
    height: $squareSize - $squareSize / 5;
    @include transform(skew(0deg, -45deg));
  }
  .shadow2 {
    z-index: 3;
    top: $squareSize / 10;
    left: $squareSize / 10 + ($squareSize / 10)/2;
    width: $squareSize - $squareSize / 5;
    height: $squareSize / 10;
    @include transform(skew(-45deg));
  }
  .stairs1,
  .stairs2,
  .stairs3,
  .stairs4 {
    li {
      position: relative;
      width: $squareSize/20;
      height: $squareSize/20;
      background-color: $light;
      box-shadow: 0px 0px 10px $light;
      @include transform(rotate(45deg));
    }
  }
  .stairs1,
  .stairs2 {
    li {
      &::before {
        content: '';
        position: absolute;
        left: 0;
        width: $squareSize/20;
        height: 13px;
        @include background-image(linear-gradient(left, $light, $shadow));
        box-shadow: 0px 0px 10px $light;
      }
    }
  }
  .stairs1 {
    top: 1px;
    left: 11px;
    width: 0px;
    height: $squareSize;
    li {
      margin-bottom: 3px;
      &::before {
        top: 100%;
      }
    }
  }
  .stairs2 {
    z-index: 10;
    bottom: 19px;
    left: 3px;
    width: $squareSize;
    height: 0px;
    display: flex;
    li {
      margin-right: 3.5px;
      &:last-child {
        &::before {
          background: $light;
        }
      }
      &::before {
        bottom: 100%;
      }
    }
  }
  .stairs3 {
    bottom: -32px;
    right: 34px;
    width: 0px;
    height: $squareSize;
    z-index: 10;
    li {
      margin-bottom: 3.5px;
    }
  }
  .stairs4 {
    top: -4px;
    left: 16px;
    width: $squareSize;
    height: 0px;
    display: flex;
    li {
      margin-right: 3.5px;
    }
//---------------------------
// PLANETS
//---------------------------
  }
}
</style>
